'use strict';

var _regeneratorRuntime = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _awaitAsyncGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var CID = require('cids');

var _require = require('multiaddr'),
    Multiaddr = _require.Multiaddr;

var toCamel = require('../lib/object-to-camel');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

var multipartRequest = require('../lib/multipart-request');

var abortSignal = require('../lib/abort-signal');

var _require2 = require('native-abort-controller'),
    AbortController = _require2.AbortController;
/**
 * @typedef {import('../types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/dht').API<HTTPClientExtraOptions>} DHTAPI
 */


module.exports = configure(function (api) {
  /**
   * @type {DHTAPI["put"]}
   */
  function put(_x, _x2) {
    return _put.apply(this, arguments);
  }

  function _put() {
    _put = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
      var options,
          controller,
          signal,
          res,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          message,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              // allow aborting requests on body errors
              controller = new AbortController();
              signal = abortSignal(controller.signal, options.signal); // @ts-ignore https://github.com/ipfs/js-ipfs-utils/issues/90

              _context.t0 = _awaitAsyncGenerator;
              _context.t1 = api;
              _context.t2 = _objectSpread;
              _context.t3 = {
                timeout: options.timeout,
                signal: signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: key
                }, options))
              };
              _context.next = 9;
              return _awaitAsyncGenerator(multipartRequest(value, controller, options.headers));

            case 9:
              _context.t4 = _context.sent;
              _context.t5 = (0, _context.t2)(_context.t3, _context.t4);
              _context.t6 = _context.t1.post.call(_context.t1, 'dht/put', _context.t5);
              _context.next = 14;
              return (0, _context.t0)(_context.t6);

            case 14:
              res = _context.sent;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 17;
              _iterator = _asyncIterator(res.ndjson());

            case 19:
              _context.next = 21;
              return _awaitAsyncGenerator(_iterator.next());

            case 21:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 31;
                break;
              }

              message = _step.value;
              message = toCamel(message);
              message.id = new CID(message.id);

              if (message.responses) {
                message.responses = message.responses.map(function (
                /** @type {{ ID: string, Addrs: string[] }} */
                _ref) {
                  var ID = _ref.ID,
                      Addrs = _ref.Addrs;
                  return {
                    id: ID,
                    addrs: (Addrs || []).map(function (a) {
                      return new Multiaddr(a);
                    })
                  };
                });
              }

              _context.next = 28;
              return message;

            case 28:
              _iteratorAbruptCompletion = false;
              _context.next = 19;
              break;

            case 31:
              _context.next = 37;
              break;

            case 33:
              _context.prev = 33;
              _context.t7 = _context["catch"](17);
              _didIteratorError = true;
              _iteratorError = _context.t7;

            case 37:
              _context.prev = 37;
              _context.prev = 38;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 42;
                break;
              }

              _context.next = 42;
              return _awaitAsyncGenerator(_iterator.return());

            case 42:
              _context.prev = 42;

              if (!_didIteratorError) {
                _context.next = 45;
                break;
              }

              throw _iteratorError;

            case 45:
              return _context.finish(42);

            case 46:
              return _context.finish(37);

            case 47:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 33, 37, 47], [38,, 42, 46]]);
    }));
    return _put.apply(this, arguments);
  }

  return put;
});